import { FC } from 'react';

import { SvgIconProps } from '@mui/material';

export const HelpIcon: FC<SvgIconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12.375v.03M7.311 6.923c0-.95.756-1.72 1.688-1.72.932 0 1.688.77 1.688 1.72S9.931 8.642 9 8.642v1.146M15.75 9a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0Z"
    />
  </svg>
);
